import { Component, Input, OnInit } from '@angular/core'; 

@Component({
    selector: 'tos',
    templateUrl: './tos.component.html',
    styleUrls: ['./../regulations.less']
})
export class TosComponent {
    @Input() showContinue: boolean = false;
}
